import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/focus-mode-delete-frame.svg'


const _hoisted_1 = { class: "fixed top-0 right-0 bottom-0 left-0 z-[999] flex items-center justify-center w-full bg-black/80" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white w-full max-w-[361px] py-4 px-5 rounded-primary-radius"
}
const _hoisted_3 = { class: "w-full flex flex-col items-center" }
const _hoisted_4 = { class: "text-primary-text-color font-semibold text-xl leading-8 tracking-[0.01rem] text-center pt-2 pb-8" }
const _hoisted_5 = { class: "w-full flex items-center justify-end gap-4" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_7 = { key: 1 }

import { useTranslate } from "@/composables/useTranslate";

import SpinnerLoader from "../Loaders/SpinnerLoader.vue";

type Props = {
  isModalOpen: boolean;
  isLoading: boolean;
  isDeleteNote: boolean;
  text: any;
};

type Emits = {
  (event: "onClose"): void;
  (event: "onImageDelete"): void;
  (event: "onCommentDelete"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FocusModeDeleteModal',
  props: {
    isModalOpen: { type: Boolean },
    isLoading: { type: Boolean },
    isDeleteNote: { type: Boolean },
    text: {}
  },
  emits: ["onClose", "onImageDelete", "onCommentDelete"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;
const { t } = useTranslate();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: !__props.isDeleteNote ? 'slide' : ''
        }, {
          default: _withCtx(() => [
            (__props.isModalOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[2] || (_cache[2] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Delete"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.text), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClose'))),
                      class: "w-full max-w-[150px] h-[44px] px-3 rounded-primary-radius bg-white border-2 border-primary-text-color leading-5 tracking-[0.01rem] font-semibold"
                    }, _toDisplayString(_unref(t)("global.cancel")), 1),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (
                __props.isDeleteNote ? emits('onCommentDelete') : emits('onImageDelete')
              )),
                      class: "w-full max-w-[150px] h-[44px] px-3 rounded-primary-radius border-2 border-primary-text-color bg-primary-text-color text-white text-base leading-5 tracking-[0.01rem] font-semibold"
                    }, [
                      (__props.isLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(SpinnerLoader)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)("global.delete")), 1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["name"])
      ], 512), [
        [_vShow, __props.isModalOpen]
      ])
    ]),
    _: 1
  }))
}
}

})